import React from 'react'
import styled from 'styled-components'

const AppIconStyled = styled.img`
    width: ${props => props.width || '22px'}; 
    height: ${props => props.height || '30px'}; 
    margin: ${props => props.margin || '0 10px'};
`


const AppIcon = ({ src, width, height, margin, ...rest }) => <AppIconStyled src={src} width={width} height={height} {...rest}></AppIconStyled>

export default AppIcon